import React from "react";
import styled from "styled-components";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalHeading
} from "src/components";
import { portalColors } from "src/components/BusinessPortalComponents";
import { DIRECTORY_LEVEL_OPTIONS } from "../../directoryLevels";

const ChooserBody = styled.div`
    display: grid;
    gap: 1.5rem;
    justify-items: center;
    padding: 0.5rem 0 0;
`;

const OptionGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.25rem;
    width: 100%;

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

const OptionCard = styled.button`
    min-height: 15rem;
    border: 1px solid ${portalColors.borderStrong};
    border-radius: 8px;
    background: ${portalColors.surface};
    box-shadow: ${portalColors.shadow};
    padding: 1.5rem 1rem;
    display: grid;
    gap: 1rem;
    justify-items: center;
    align-content: space-between;
    color: ${portalColors.text};
    cursor: pointer;
    text-align: center;

    &:hover,
    &:focus-visible {
        border-color: ${portalColors.blue};
        box-shadow: 0 0 0 4px ${portalColors.blueSoft};
        outline: none;
    }
`;

const OptionTitle = styled.h3`
    margin: 0;
    font-size: 1.35rem;
    line-height: 1.15;
    color: ${portalColors.blue};
`;

const OptionText = styled.p`
    margin: 0;
    color: ${portalColors.text};
    font-size: 0.85rem;
    line-height: 1.3;
`;

const Example = styled.p`
    margin: 0;
    color: ${portalColors.mutedText};
    font-size: 0.78rem;
    line-height: 1.35;
    font-weight: 700;
`;

const optionCopy = {
    subcategory: {
        description: "Add a new Sub-Category within an existing main Category.",
        example: "Meditation > Sleep"
    },
    topic: {
        description: "Add a new Topic within an existing Sub-Category to organise content into a more specific group.",
        example: "Meditation > Sleep > Sleep Stories"
    },
    subtopic: {
        description: "Add a new Sub-Topic within an existing Topic for an additional level of content organisation.",
        example: "Meditation > Sleep > Sleep Stories > Children"
    }
};

export function DirectoryTypeChooser({ open, onClose, onSelect }) {
    return (
        <StandardModal
            open={open}
            onClose={onClose}
            widthMode="large"
            hideCloseButton
            footer={(
                <StandardModalActionGroup $center>
                    <StandardModalActionButton onClick={onClose}>Cancel</StandardModalActionButton>
                </StandardModalActionGroup>
            )}
        >
            <ChooserBody>
                <div style={{ textAlign: "center", display: "grid", gap: "0.5rem" }}>
                    <StandardModalHeading align="center">What would you like to create?</StandardModalHeading>
                    <StandardModalDescription align="center" color={portalColors.mutedText}>
                        Select the type of item you want to add to your Body & Mind content structure.
                    </StandardModalDescription>
                </div>
                <OptionGrid>
                    {DIRECTORY_LEVEL_OPTIONS.map(option => (
                        <OptionCard key={option.value} type="button" onClick={() => onSelect(option.value)}>
                            <OptionTitle>{option.label}</OptionTitle>
                            <OptionText>{optionCopy[option.value].description}</OptionText>
                            <Example>Example<br />{optionCopy[option.value].example}</Example>
                            <StandardModalActionButton $variant="primary" type="button" width="11rem">
                                {option.createLabel}
                            </StandardModalActionButton>
                        </OptionCard>
                    ))}
                </OptionGrid>
            </ChooserBody>
        </StandardModal>
    );
}
